export default __webpack_public_path__ + "static/media/card_container_skeleton_mobile.bda26462.png";